import axios from "axios";
import router from '@/router'
import store from "@/store";
import Swal from 'sweetalert2'

const errorHandler = (status, msg) => {
  console.error(status + ":" + msg)
  const token = store.state.auth.token

  switch (status) {
    case 401:
      if (token) {
        store.dispatch('auth/logout').then(async () => {
          await Swal.fire({
            title: '登入時效已過期',
            type: 'error'
          });
          const org_code = store.state.general.currentOrgCode ?? null
          router.push({ name: 'AuthLogin', params: { org_code: org_code }})
        });
      }
      break
    // 交由 src/router/middlewares/initDashboardGeneralData middleware 來顯示錯誤訊息
    // case 403:
    //   alert('您沒有存取此組織的權限')
    //   break
  }
};

var instance = axios.create({
  baseURL: process.env.VUE_APP_API_BASE_URL,
});

instance.interceptors.request.use(
  (config) => {
    // 判斷是否為 tongxin API 請求
    const isTongxinApi = config.url && config.url.includes('/tongxin/')

    if (isTongxinApi) {
      // tongxin 頁面：由 tongxin store 決定 token
      const tongxinToken = store.getters['web/tongxin/resolveToken']
      if (tongxinToken) {
        config.headers.Authorization = "Bearer " + tongxinToken
      }
    } else {
      // 非 tongxin 頁面：維持原有優先順序
      const ec91JwtToken = store.getters['web/ec-91-auth/jwtToken']

      if (ec91JwtToken) {
        config.headers.Authorization = "Bearer " + ec91JwtToken
      } else {
        const token = store.state.auth.token
        if (token) {
          config.headers.Authorization = "Bearer " + token
        } else {
          const liffToken = store.state.liffAuth?.token
          if (liffToken) {
            config.headers.Authorization = "Bearer " + liffToken
          }
        }
      }
    }
    return config
  },
  (error) => {
    return Promise.reject(error)
  }
);

instance.interceptors.response.use(
  (response) => {
    return response
  },
  (error) => {
    const { response, config } = error
    const isTongxinApi = config && config.url && config.url.includes('/tongxin/')
    const isGuest = store.getters['web/tongxin/isGuest']

    // Guest 模式下 tongxin API 的 401 不觸發全域 logout/redirect
    if (isTongxinApi && isGuest && response && response.status === 401) {
      return Promise.reject(error)
    }

    errorHandler(response.status, response.data.error || response.data.message)
    return Promise.reject(error)
  }
);

export default instance;
